export default "__VITE_ASSET__BZbPjmbk__"